/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardResponseObject } from './RewardResponseObject';
import {
    RewardResponseObjectFromJSON,
    RewardResponseObjectFromJSONTyped,
    RewardResponseObjectToJSON,
    RewardResponseObjectToJSONTyped,
} from './RewardResponseObject';

/**
 * 
 * @export
 * @interface ManualDistributeRewardResponse
 */
export interface ManualDistributeRewardResponse {
    /**
     * 
     * @type {Array<RewardResponseObject>}
     * @memberof ManualDistributeRewardResponse
     */
    rewards: Array<RewardResponseObject>;
}

/**
 * Check if a given object implements the ManualDistributeRewardResponse interface.
 */
export function instanceOfManualDistributeRewardResponse(value: object): value is ManualDistributeRewardResponse {
    if (!('rewards' in value) || value['rewards'] === undefined) return false;
    return true;
}

export function ManualDistributeRewardResponseFromJSON(json: any): ManualDistributeRewardResponse {
    return ManualDistributeRewardResponseFromJSONTyped(json, false);
}

export function ManualDistributeRewardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualDistributeRewardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rewards': ((json['rewards'] as Array<any>).map(RewardResponseObjectFromJSON)),
    };
}

export function ManualDistributeRewardResponseToJSON(json: any): ManualDistributeRewardResponse {
    return ManualDistributeRewardResponseToJSONTyped(json, false);
}

export function ManualDistributeRewardResponseToJSONTyped(value?: ManualDistributeRewardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rewards': ((value['rewards'] as Array<any>).map(RewardResponseObjectToJSON)),
    };
}

